import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    standalone: true,
    name: 'initials'
})
export class InitialsPipe implements PipeTransform {

    transform(value: string): string {
        if (!value) return '';

        const names = value.trim().split(' ').filter(name => name.length > 0);

        if (names.length === 1) {
            const firstName = names[0];
            const firstInitial = firstName.charAt(0).toUpperCase();
            const firstVowel = this.findFirstVowel(firstName)?.toUpperCase() || firstName.charAt(1).toUpperCase();
            return `${firstInitial}${firstVowel}`;
        }

        const initials = names.map(name => name.charAt(0).toUpperCase());
        return `${initials[0]}${initials[initials.length - 1]}`;
    }

    private findFirstVowel(word: string): string {
        const normalizedWord = word.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // Remove acentos
        const vowels = 'aeiouAEIOU';
        for (const char of normalizedWord) {
            if (vowels.includes(char)) {
                return char;
            }
        }
        return '';
    }
}
